module.exports = __webpack_public_path__ + "img/Open-ended_Feedback_24.0f17a704.png";